/**
 * RatePunk Hotel Booking Deals — hotel price comparison
 *
 * Its single web-accessible-resource entry lists ~170 concrete image files (no glob,
 * no `use_dynamic_url`), matched to a long list of travel-site origins — Airbnb,
 * Booking, Expedia, Tripadvisor and so on. The resources are static and fetchable at a
 * fixed URL, but only from one of those origins; from any other page the fetch fails.
 *
 * We probe from `https://www.airbnb.dk`, one of the declared matches, for the
 * vendor-named `images/ratepunk.svg`.
 *
 * Manifest verified against version 1.49.8.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gdaioanblcnghddimngklkhgcbomfdck';

export const ratepunk: ExtensionDefinition = {
  id: ID,
  name: 'RatePunk Hotel Booking Deals',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 50_000,
  requiredOrigin: 'https://www.airbnb.dk',
  notes:
    'Static, individually-listed WAR scoped to travel-site origins, so only those ' +
    'pages can detect it. The vendor-named ratepunk.svg makes it conclusive there.',
  signals: [
    {
      id: 'war-ratepunk-logo-svg',
      kind: 'web-accessible-resource',
      description:
        'Fetch images/ratepunk.svg — the vendor logo, static but only exposed to the ' +
        'declared travel-site origins.',
      weight: 1,
      run: () => probeFetch(ID, 'images/ratepunk.svg'),
    },
    {
      id: 'war-rp-logo-small-svg',
      kind: 'web-accessible-resource',
      description:
        'Fetch images/rp-logo-small.svg — a second vendor-named (rp-) asset, ' +
        'corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'images/rp-logo-small.svg'),
    },
  ],
};
